import { __ } from '@wordpress/i18n'
;(function ($) {
	$.ardentLocation = function (element, options, Map, AdvancedMarkerElement, PinElement) {
		let base = this
		base.element = element
		base.markers = []
		base.bounds = new window.google.maps.LatLngBounds()
		base.infowindow = new window.google.maps.InfoWindow()
		base.map = null

		// eslint-disable-next-line no-unused-vars
		base.target_id = $(element).attr('id')
		// This is the easiest way to have default options.
		// eslint-disable-next-line no-unused-vars
		base.settings = $.extend(
			{
				// These are the defaults.
				location: {},
				mapSettings: {},
			},
			options
		)

		base.init = function () {
			initMap()
			defineLocation()
			return base
		}

		let defineLocation = function () {
			let location = base.settings.location
			let latitude = location.latitude ? location.latitude : ''
			let longitude = location.longitude ? location.longitude : ''
			if (!latitude || !longitude) {
				return
			}
			const pin = new PinElement()
			if (base.settings.mapSettings.colors && 0 < Object.keys(base.settings.mapSettings.colors).length) {
				let colors = base.settings.mapSettings.colors
				if (colors.primary) {
					pin.background = colors.primary
				}
				if (colors.secondary) {
					pin.glyphColor = colors.secondary
				}
				if (colors.border) {
					pin.borderColor = colors.border
				}
			}
			const marker = new AdvancedMarkerElement({
				position: new window.google.maps.LatLng(latitude, longitude),
				map: base.map,
				content: pin.element,
				title: location.locationName,
			})
			marker.dataset.locationId = location.entityId
			marker.dataset.location = location

			base.markers.push(marker)

			// let listing_template = get_location_listing_template(location)

			// Add descriptions to map markers.
			window.google.maps.event.addListener(
				marker,
				'click',
				(marker => {
					return () => {
						const layout = get_info_window_template(location)
						// const selected_location = document.getElementById(`location_${marker.locationID}_js`)
						// const selected_location_top = selected_location.offsetTop
						// document.getElementById('location__map').scrollTop = selected_location_top

						base.infowindow.setContent(layout)
						base.infowindow.open(base.map, marker)
					}
				})(marker, 0)
			)

			// Extend the bounds to include each marker's position
			base.bounds.extend(marker.position)
		}

		let initMap = function () {
			const map_element = document.querySelector(base.settings.mapSettings.map)
			const gestureType = isTouchDevice() ? 'cooperative' : 'greedy'

			base.map = new Map(map_element, {
				mapTypeControl: false,
				mapTypeControlOptions: {
					style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
					position: window.google.maps.ControlPosition.TOP_CENTER,
				},
				zoomControl: true,
				zoomControlOptions: {
					position: window.google.maps.ControlPosition.RIGHT_CENTER,
				},
				scaleControl: true,
				streetViewControl: false,
				streetViewControlOptions: {
					position: window.google.maps.ControlPosition.LEFT_TOP,
				},
				fullscreenControl: false,
				options: {
					gestureHandling: gestureType,
				},
				mapId: base.target_id,
			})

			window.google.maps.event.addListener(base.map, 'zoom_changed', function () {
				const zoomChangeBoundsListener = window.google.maps.event.addListener(
					base.map,
					'bounds_changed',
					function () {
						if (this.getZoom() > 15 && this.initialZoom == true) {
							// Change max/min zoom here
							this.setZoom(15)
							this.initialZoom = false
						}
						if (this.getZoom() < 3 && this.initialZoom == true) {
							// Change max/min zoom here
							this.setZoom(3)
							this.initialZoom = false
						}
						window.google.maps.event.removeListener(zoomChangeBoundsListener)
					}
				)
			})

			set_map(base.map, base.bounds)
			window.bounds = base.bounds
			window.location_markers = base.markers
		}

		let isTouchDevice = function () {
			return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
		}

		let set_map = function (map, bounds) {
			map.initialZoom = true

			if (window.innerWidth <= 1031) {
				map.fitBounds(bounds, 20)
			} else {
				map.fitBounds(bounds, 100)
			}
		}

		let get_info_window_template = function () {
			let locationAddress = ''
			let locationPhone = ''
			let location = base.settings.location
			if (location.address1 && location.state) {
				locationAddress +=
					'<p><a class="location__item__address" itemprop="address" itemscope itemtype="https://schema.org/PostalAddress"'

				locationAddress +=
					' href="https://www.google.com/maps/dir/?api=1&destination=' +
					location.latitude +
					'+' +
					location.longitude +
					'" target="_blank">'

				locationAddress +=
					'<span itemprop="streetAddress" class="streetAddress">' +
					[location.address1, location.address2].join('<br>') +
					'</span><br>'
				let locationCity = location.city ? '<span itemprop="addressLocality">' + location.city + '</span>' : ''
				let locationState = location.state ? '<span itemprop="addressRegion">' + location.state + '</span>' : ''
				locationAddress += [locationCity, locationState].join(', ')
				locationAddress += location.zip ? ' <span itemprop="postalCode">' + location.zip + '</span>' : ''
				locationAddress += '</a></p>'
			}
			if (location.phone) {
				locationPhone =
					'<p><a class="location__item__phone" itemprop="telephone" href="tel:' +
					location.phone.replace(/\D+/g, '') +
					'">' +
					'<svg class="location__item__phone-icon location__item__icon" viewbox="0 0 512 512"><use href="#location_phone"></use></svg>&nbsp;' +
					location.phone +
					'</a></p>'
			}

			let location_url =
				'https://www.google.com/maps/dir/?api=1&destination=' + location.latitude + '+' + location.longitude

			return `<div class="info-window-container" itemscope itemtype="https://schema.org/Organization">
						<h3 itemprop="name" class="info-window-container__title">${location.locationName}</h3>
						${locationAddress}
						${locationPhone}
						<p class="info-window-container__cta">
							<a class="button secondary expanded" href="${location_url}">
								${__('View on Google Maps', 'ahms')}
							</a>
						</p>
					</div>`
		}
	}

	$.fn.ardentLocation = function (options, Map, AdvancedMarkerElement, PinElement) {
		return this.each(function () {
			$(this).data(
				'ardentLocation',
				new $.ardentLocation(this, options, Map, AdvancedMarkerElement, PinElement).init()
			)
			$(this).trigger('locationsLoaded')
		})
	}
})(jQuery)

class TabbedContent {
	constructor(containerSelector) {
		this.container = document.querySelector(containerSelector)

		// Bail out cleanly when there's no tab container on the page. The
		// Location detail view constructs TabbedContent unconditionally but
		// renders no `.location__item__tab-container`, so container is null
		// there; without this guard the next line throws
		// "Cannot read properties of null (reading 'querySelectorAll')".
		if (!this.container) {
			return
		}

		this.tabButtons = this.container.querySelectorAll('.location__item__tab-button')
		this.tabPanels = this.container.querySelectorAll('.location__item__tab-panel')

		// Add initial ARIA live region for announcements
		this.createLiveRegion()
		this.init()
	}

	createLiveRegion() {
		const liveRegion = document.createElement('div')
		liveRegion.id = 'tab-announcements'
		liveRegion.setAttribute('aria-live', 'polite')
		liveRegion.setAttribute('aria-atomic', 'true')
		liveRegion.className = 'sr-only'
		liveRegion.style.cssText = 'position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;'
		document.body.appendChild(liveRegion)
		this.liveRegion = liveRegion
	}

	init() {
		this.tabButtons.forEach(button => {
			button.addEventListener('click', e => this.handleTabClick(e))
		})

		// Add keyboard navigation
		this.container.addEventListener('keydown', e => this.handleKeyNavigation(e))
	}

	handleTabClick(e) {
		const clickedTab = e.target.dataset.tab
		this.switchTab(clickedTab)

		// Update focus for keyboard navigation
		this.updateTabIndex(e.target)
	}

	switchTab(targetTab) {
		// Update dynamic ARIA states for all buttons and panels
		this.tabButtons.forEach(btn => {
			btn.classList.remove('active')
			btn.setAttribute('aria-selected', 'false')
			btn.setAttribute('tabindex', '-1')
		})
		this.tabPanels.forEach(panel => {
			panel.classList.remove('active')
			panel.setAttribute('aria-hidden', 'true')
		})

		// Activate target button and panel
		const targetButton = this.container.querySelector(`[data-tab="${targetTab}"]`)
		const targetPanel = this.container.querySelector(`#${targetTab}`)

		if (targetButton && targetPanel) {
			targetButton.classList.add('active')
			targetButton.setAttribute('aria-selected', 'true')
			targetButton.setAttribute('tabindex', '0')
			targetPanel.classList.add('active')
			targetPanel.setAttribute('aria-hidden', 'false')

			// Focus the panel for screen reader users
			targetPanel.focus()

			// Update document title for better UX
			const tabText = targetButton.textContent.trim()

			// Announce to screen readers
			this.announceTabChange(tabText)
		}
	}

	handleKeyNavigation(e) {
		const focusedElement = document.activeElement
		const isTabButton = focusedElement.classList.contains('tab-button')

		if (!isTabButton) return

		const currentIndex = Array.from(this.tabButtons).indexOf(focusedElement)
		let newIndex

		switch (e.key) {
			case 'ArrowLeft':
				e.preventDefault()
				newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabButtons.length - 1
				break
			case 'ArrowRight':
				e.preventDefault()
				newIndex = currentIndex < this.tabButtons.length - 1 ? currentIndex + 1 : 0
				break
			case 'Home':
				e.preventDefault()
				newIndex = 0
				break
			case 'End':
				e.preventDefault()
				newIndex = this.tabButtons.length - 1
				break
			case 'Enter':
			case ' ':
				e.preventDefault()
				this.handleTabClick({ target: focusedElement })
				return
			default:
				return
		}

		if (newIndex !== undefined) {
			this.tabButtons[newIndex].focus()
			this.updateTabIndex(this.tabButtons[newIndex])
		}
	}

	updateTabIndex(activeButton) {
		this.tabButtons.forEach(button => {
			button.setAttribute('tabindex', button === activeButton ? '0' : '-1')
		})
	}

	announceTabChange(tabName) {
		// Use the persistent live region for announcements
		if (this.liveRegion) {
			this.liveRegion.textContent = `${tabName} tab selected`
			// Clear the announcement after a short delay
			setTimeout(() => {
				if (this.liveRegion) {
					this.liveRegion.textContent = ''
				}
			}, 1000)
		}
	}
}

// Export for module systems (webpack, etc.)
if (typeof module !== 'undefined' && module.exports) {
	module.exports = TabbedContent
} else if (typeof exports !== 'undefined') {
	exports.TabbedContent = TabbedContent
}

// Make available globally as well
if (typeof window !== 'undefined') {
	window.TabbedContent = TabbedContent
}
